import { render } from "./ProfileSettingsBio.vue?vue&type=template&id=06254e8c&ts=true"
import script from "./ProfileSettingsBio.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsBio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__